import React from 'react';
import { AlertCircle, X } from 'lucide-react';
import { Alert, AlertTitle, AlertDescription } from './ui/alert';

const TokenExpirationAlert = ({ onRenew, onClose, remainingTime }) => {
  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-md animate-slide-up">
      <Alert className="bg-yellow-50 border-yellow-200 text-yellow-800 relative">
        <AlertCircle className="h-4 w-4" />
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-yellow-600 hover:text-yellow-800"
        >
          <X className="h-4 w-4" />
        </button>
        <AlertTitle className="text-yellow-800">Session Expiring Soon</AlertTitle>
        <AlertDescription className="mt-2">
          <p className="text-sm">
            Your session will expire in {Math.ceil(remainingTime / 60)} minutes.
          </p>
          <button
            onClick={onRenew}
            className="mt-2 px-3 py-1.5 bg-yellow-100 hover:bg-yellow-200 text-yellow-800 rounded-md text-sm font-medium transition-colors"
          >
            Extend Session
          </button>
        </AlertDescription>
      </Alert>
    </div>
  );
};

export default TokenExpirationAlert;